"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectToken = void 0;
var selectToken = function (_a) {
    var auth = _a.auth;
    return auth.token;
};
exports.selectToken = selectToken;
//# sourceMappingURL=authToken.selectors.js.map